'use strict';

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

module.exports = function (options/*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (options == null) return;
		process(Object(options), result);
	});
	return result;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/es5-ext/object/normalize-options.js
 ** module id = 70
 ** module chunks = 2
 **/